import type { FaqEntry } from "@/lib/structuredData";

/**
 * Plain-text FAQ copy, shared by the landing page accordion schema and the
 * /faq page. Source of truth: docs/content/published/website/copy.md.
 */
export const FAQ_ENTRIES: ReadonlyArray<FaqEntry> = [
  {
    question: "What is Stasht?",
    answer:
      "Stasht is like that friend who actually remembers what you’re into. You send us the things you find online — restaurants, events, products, travel ideas, recipes — and we organize them, pull out the details, and bring them back to you when they matter.",
  },
  {
    question: "What platforms does Stasht work with?",
    answer:
      "Instagram, X, TikTok, Reddit, YouTube, Pinterest, and the web. You can bulk import existing saves with the Chrome extension on desktop or the Safari extension on Mac, iPhone, and iPad.",
  },
  {
    question: "Can I import saves I’ve already made on other apps?",
    answer:
      "Yes. Stasht can bulk import existing saves with the Chrome extension on desktop or the Safari extension on Mac, iPhone, and iPad. In Safari, log into the supported sites you want to import from, then bring those saves into Stasht. You can also sync your X account in Profile › Account Settings › Connected Accounts to pull in all your old bookmarks. Either way, everything gets automatically organized the moment it lands.",
  },
  {
    question: "What devices can I use Stasht on?",
    answer: "iPhone, iPad, Android, and desktop. Your stash syncs across all of them.",
  },
  {
    question: "How is this different from saving posts on Instagram?",
    answer:
      "Instagram saves stay on Instagram. They don’t tell you what’s inside, they don’t organize themselves, and they don’t come back to you. Stasht works across every platform and does the work your saves were never going to do on their own.",
  },
  {
    question: "Is Stasht free?",
    answer: "Yes. We’re early and focused on building the best experience we can. Just download and start stashing.",
  },
  {
    question: "Can businesses or content creators use Stasht?",
    answer: "We’re building for that. If you’re interested, reach out at business@stasht.app.",
  },
];
